import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { ProfileService, UserRole } from '../profile.service';

export const authGuard: CanActivateFn = (route) => {
  const profileService = inject(ProfileService);
  const router = inject(Router);

  const allowedRoles: UserRole[] = route.data['role'];
  const role = profileService.role();

  if (role && allowedRoles.includes(role)) {
    return true;
  }

  void router.navigate(['/login']);
  return false;
};
